import { ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const merge = extendTailwindMerge({ extend: { theme: { text: ['xxs'] } } });

export const cn = (...inputs: ClassValue[]): string => merge(clsx(inputs));
